import { createContext, useState, useContext } from 'react';

const CompanyContext = createContext();

export const useCompany = () => useContext(CompanyContext);

export const CompanyProvider = ({ children }) => {
  const [overallCompany, setOverallCompany] = useState(null);

  return (
    <CompanyContext.Provider value={{ overallCompany, setOverallCompany }}>
      {children}
    </CompanyContext.Provider>
  );
};